<template>
  <el-dialog
  class="dialogCommon dialogCustom"
  width="500px"
  v-bind="$attrs"
  :close-on-click-modal="false"
  append-to-body
  :before-close="handleClose">
  <div class="content">
    <slot></slot>
  </div>
  <span slot="footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="handleConfirm" :loading="loading">确 定</el-button>
  </span>
</el-dialog>
</template>
<script>
  export default {
    props:{
      loading:false
    },
    data() {
      return {
      };
    },
    methods: {
      handleConfirm(){
        this.$emit('handleConfirm')
      },
      handleClose() {
        this.$emit('handleClose')
      }
    }
  };
</script>
<style lang="less" scoped>
.dialogCommon{
  margin-top: 10%;
  /deep/ .el-dialog__body{
    padding: 20px 32px 30px 32px;
  }
  .content{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.dialogCommon /deep/ .el-checkbox__label{
  font-size:12px;
}
</style>